module.exports = __webpack_public_path__ + "img/sh_14.85e6235b.jpg";